var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shiftStore.data[_vm.location].shifts.length === 0)?_c('div',{on:{"click":function($event){return _vm.shiftStore.loadData(_vm.location, _vm.numOfShifts)}}},[_c('br'),_vm._v("\n    Loading "+_vm._s(_vm.location)+" Shifts...\n\n  ")]):_c('div',[_c('h3',[_vm._v(_vm._s(_vm.location))]),_c('BasicTableComponent',{attrs:{"list":_vm.shiftStore.daysWithTotals(_vm.location),"totals":_vm.shiftStore.monthTotals(_vm.location),"tableClass":"table2excel","tableID":_vm.location,"formatters":{
          'day' : ['d', 'ddd MM/DD/YY'], 
          'StartDateTime' : ['d', 'h:mm a'], 
          'EndDateTime' : ['d', 'h:mm a'], 
          'Start' : ['d', 'h:mm a'], 
          'End' : ['d', 'h:mm a'], 
          'Hours' : ['n', '0,0.00'], 
          'RoundedHours' : ['n', '0,0.00'], 
        },"titles":{
          'StartDateTime' : 'Shift Start', 
          'EndDateTime' : 'Shift End', 
          'RoundedHours' : 'Rounded Hours',
          'NetSalesTaxed' : 'Net Sales <br/>Taxed',
          'NetSalesNonTaxed' : 'Net Sales <br/>Non Taxed',
          'safeDropsCRE' : 'Safe Drops <br/>CRE',
          'safeDropsSafe' : 'Safe Drops <br/>Safe',
        }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }